import { parseDate } from './date';

export const deserializeDate = (date: string | null) => {
  if (date) {
    return parseDate(date);
  } else {
    return null;
  }
};
